import Validate from "./libs/snake.lib.validate";

const config = {
    payments: {
        paypal: "PayPal",
        sepadirectdebit: "Direct Debit",
        card: "Credit Card",
        c_invoice: "Open Invoice",
        c_cash: "Cash",
        applepay: "Apple Pay",
    },
    countries: {
        us: {
            lang: "en",
            displayName: "United States of America",
            countryCodeGigya: "USA",
            countryCode: "US",
            state: null,
            key: "US",
            phonePrefix: "+1",
            currencySymbol: "$",
            currencyCode: "USD",
            states: [
                {
                    label: "Idaho",
                    value: "ID",
                },
                {
                    label: "Michigan",
                    value: "MI",
                },
                {
                    label: "Maryland",
                    value: "MD",
                },
                {
                    label: "Iowa",
                    value: "IA",
                },
                {
                    label: "Maine",
                    value: "ME",
                },
                {
                    label: "US Minor Outlying Islands",
                    value: "UM",
                },
                {
                    label: "Massachusetts",
                    value: "MA",
                },
                {
                    label: "Delaware",
                    value: "DE",
                },
                {
                    label: "Hawaii",
                    value: "HI",
                },
                {
                    label: "Puerto Rico",
                    value: "PR",
                },
                {
                    label: "Texas",
                    value: "TX",
                },
                {
                    label: "District of Columbia",
                    value: "DC",
                },
                {
                    label: "Arizona",
                    value: "AZ",
                },
                {
                    label: "New Hampshire",
                    value: "NH",
                },
                {
                    label: "New Jersey",
                    value: "NJ",
                },
                {
                    label: "North Carolina",
                    value: "NC",
                },
                {
                    label: "North Dakota",
                    value: "ND",
                },
                {
                    label: "Nebraska",
                    value: "NE",
                },
                {
                    label: "Rhode Island",
                    value: "RI",
                },
                {
                    label: "Arkansas",
                    value: "AR",
                },
                {
                    label: "American Samoa",
                    value: "AS",
                },
                {
                    label: "Virgin Islands",
                    value: "VI",
                },
                {
                    label: "Alaska",
                    value: "AK",
                },
                {
                    label: "Alabama",
                    value: "AL",
                },
                {
                    label: "Virginia",
                    value: "VA",
                },
                {
                    label: "Indiana",
                    value: "IN",
                },
                {
                    label: "Mississippi",
                    value: "MS",
                },
                {
                    label: "Montana",
                    value: "MT",
                },
                {
                    label: "Minnesota",
                    value: "MN",
                },
                {
                    label: "Missouri",
                    value: "MO",
                },
                {
                    label: "Illinois",
                    value: "IL",
                },
                {
                    label: "Northern Mariana Islands",
                    value: "MP",
                },
                {
                    label: "Utah",
                    value: "UT",
                },
                {
                    label: "Ohio",
                    value: "OH",
                },
                {
                    label: "Georgia",
                    value: "GA",
                },
                {
                    label: "Oklahoma",
                    value: "OK",
                },
                {
                    label: "South Dakota",
                    value: "SD",
                },
                {
                    label: "Wisconsin",
                    value: "WI",
                },
                {
                    label: "South Carolina",
                    value: "SC",
                },
                {
                    label: "Washington",
                    value: "WA",
                },
                {
                    label: "New York",
                    value: "NY",
                },
                {
                    label: "Florida",
                    value: "FL",
                },
                {
                    label: "Nevada",
                    value: "NV",
                },
                {
                    label: "Vermont",
                    value: "VT",
                },
                {
                    label: "New Mexico",
                    value: "NM",
                },
                {
                    label: "Tennessee",
                    value: "TN",
                },
                {
                    label: "Louisiana",
                    value: "LA",
                },
                {
                    label: "Connecticut",
                    value: "CT",
                },
                {
                    label: "Pennsylvania",
                    value: "PA",
                },
                {
                    label: "Kentucky",
                    value: "KY",
                },
                {
                    label: "Colorado",
                    value: "CO",
                },
                {
                    label: "Kansas",
                    value: "KS",
                },
                {
                    label: "Wyoming",
                    value: "WY",
                },
                {
                    label: "Oregon",
                    value: "OR",
                },
                {
                    label: "California",
                    value: "CA",
                },
                {
                    label: "West Virginia",
                    value: "WV",
                },
            ],
        },
        uk: {
            lang: "en",
            code: "GB",
            displayName: "United Kingdom",
            countryCodeGigya: "GBR",
            countryCode: "UK",
            state: "LND",
            key: "UK",
            phonePrefix: "+44",
            currencySymbol: "£",
            currencyCode: "GBP",
        },
        at: {
            lang: "de",
            displayName: "Österreich",
            countryCodeGigya: "AUT",
            countryCode: "AT",
            state: "9",
            key: "AT",
            phonePrefix: "+43",
            currencySymbol: "€",
            currencyCode: "EUR",
        },
        nl: {
            displayName: "Nederland",
            countryCodeGigya: "NLD",
            countryCode: "NL",
            state: "NH",
            key: "NL",
            phonePrefix: "+31",
            currencySymbol: "€",
            currencyCode: "EUR",
        },
        de: {
            displayName: "Deutschland",
            countryCodeGigya: "DEU",
            countryCode: "DE",
            state: "BW",
            key: "DE",
            phonePrefix: "+49",
            currencySymbol: "€",
            currencyCode: "EUR",
        },
        gr: {
            lang: "el",
            displayName: "Ελλάδα",
            countryCodeGigya: "GRC",
            countryCode: "GR",
            state: "E",
            key: "GR",
            phonePrefix: "+30",
            currencySymbol: "€",
            currencyCode: "EUR",
        },
        pl: {
            displayName: "Polska",
            countryCodeGigya: "POL",
            countryCode: "PL",
            state: "KP",
            key: "PL",
            phonePrefix: "+48",
            currencySymbol: "zł",
            currencyCode: "PLN",
        },
        it: {
            displayName: "Italia",
            countryCodeGigya: "ITA",
            countryCode: "IT",
            state: "34",
            key: "IT",
            phonePrefix: "+39",
            currencySymbol: "€",
            currencyCode: "EUR",
        },
        cz: {
            lang: "cs",
            displayName: "Česká republika",
            countryCodeGigya: "CZE",
            countryCode: "CZ",
            state: "JM",
            key: "CZ",
            phonePrefix: "+420",
            currencySymbol: "Kč",
            currencyCode: "CZK",
        },
        sk: {
            displayName: "Slovensko",
            countryCodeGigya: "SVK",
            countryCode: "SK",
            state: "BC",
            key: "SK",
            phonePrefix: "+421",
            currencySymbol: "€",
            currencyCode: "EUR",
        },
        fr: {
            displayName: "France",
            countryCodeGigya: "FRA",
            countryCode: "FR",
            state: "BC",
            key: "FR",
            phonePrefix: "+33",
            currencySymbol: "€",
            currencyCode: "EUR",
        },
        es: {
            displayName: "España",
            countryCodeGigya: "ESP",
            countryCode: "ES",
            state: "BC",
            key: "ES",
            phonePrefix: "+34",
            currencySymbol: "€",
            currencyCode: "EUR",
        },
        be: {
            lang: "fr",
            displayName: "Belgium",
            countryCodeGigya: "BEL",
            countryCode: "BE",
            state: "BC",
            key: "BE",
            phonePrefix: "+32",
            currencySymbol: "€",
            currencyCode: "EUR",
        },
        pt: {
            displayName: "Portugal",
            countryCodeGigya: "PRT",
            countryCode: "PT",
            state: "",
            key: "PT",
            phonePrefix: "+351",
            currencySymbol: "€",
            currencyCode: "EUR",
        },
    },
    routing: {
        sections: {
            load: {
                component: "_cmpLoad",
            },
            agent: {
                component: "_cmpAgent",
            },
            profile: {
                component: "_cmpProfile",
            },
            premiumBanner: {
                component: "_cmpPremiumBanner",
            },
            commerceBanner: {
                component: "_cmpCommerceBanner",
            },
            addresses: {
                component: "_cmpAddresses",
            },
            payment: {
                component: "_cmpPayment",
            },
        },
    },
    validation: {
        rules: {
            agentRequired: {
                required: {
                    error: "The field is required.",
                },
            },
            label: {
                regex: {
                    // eslint-disable-next-line no-control-regex
                    value: /^([^\x00-\xBF]|[a-zA-Z0-9])*$/,
                    postValidation: (element, isValid) => {
                        validateTags(element, isValid);

                        return isValid;
                    },
                    error: window.snakeCheckout.translations["error.field.label.regex"],
                },
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
            },
            email: {
                regex: {
                    value: /^(?!\.)(?=.{1,64}@)([a-zA-Z0-9_]((?!.*\+\+)(?!.*\.\.)[a-zA-Z0-9._+-]{0,62})[a-zA-Z0-9_-]|^[a-zA-Z0-9_]{1,64})@(?:[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]\.)+[a-zA-Z]{2,}$/,
                    error: window.snakeCheckout.translations["error.field.email.regex"],
                },
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
                providers: {
                    "email.checker": {},
                },
            },
            password: {
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
            },
            name: {
                regex: {
                    // eslint-disable-next-line no-control-regex
                    value: /^([^\x00-\xBF]|[a-zA-Z\s']){2,}$/,
                    error: window.snakeCheckout.translations["error.field.name.regex"],
                },
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
            },
            country: {
                regex: {
                    value: /^[\p{L}\p{N} ',.()-]*$/u,
                    error: window.snakeCheckout.translations["error.field.address.regex"],
                },
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
            },
            addressAutocomplete: {
                regex: {
                    value: /^[\p{L}\p{N} ',.()-]*$/u,
                    error: window.snakeCheckout.translations["error.field.address.regex"],
                },
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
                providers: {
                    "google.autocomplete.address": {
                        fields: {
                            city: "city",
                            zip: "zip",
                            number: "number",
                            state: "state",
                        },
                    },
                },
            },
            cityAutocomplete: {
                regex: {
                    value: /^[\p{L}\p{N} ',.()-]*$/u,
                    error: window.snakeCheckout.translations["error.field.address.regex"],
                },
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
                providers: {
                    "google.autocomplete.city": {
                        fields: {
                            city: "city",
                        },
                    },
                },
            },
            billingAddressAutocomplete: {
                regex: {
                    value: /^[\p{L}\p{N} ',.()-]*$/u,
                    error: window.snakeCheckout.translations["error.field.name.regex"],
                },
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
                providers: {
                    "google.autocomplete.address": {
                        fields: {
                            city: "billingCity",
                            zip: "billingZip",
                            number: "billingNumber",
                            state: "billingState",
                        },
                    },
                },
            },
            billingCityAutocomplete: {
                regex: {
                    value: /^[\p{L}\p{N} ',.()-]*$/u,
                    error: window.snakeCheckout.translations["error.field.address.regex"],
                },
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
                providers: {
                    "google.autocomplete.city": {
                        fields: {
                            city: "billingCity",
                        },
                    },
                },
            },
            street: {
                regex: {
                    value: /^[\p{L}\p{N} ',.()-]*$/u,
                    error: window.snakeCheckout.translations["error.field.address.regex"],
                },
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
            },
            city: {
                regex: {
                    value: /^[\p{L}\p{N} ',.()-]*$/u,
                    error: window.snakeCheckout.translations["error.field.address.regex"],
                },
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
            },
            state: {
                regex: {
                    value: /^[\p{L}\p{N} ',.()-]*$/u,
                    postValidation: (element, isValid) => {
                        validateTags(element, isValid);

                        return isValid;
                    },
                    error: window.snakeCheckout.translations["error.field.address.regex"],
                },
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
            },
            zip: {
                regex: {
                    // eslint-disable-next-line no-control-regex
                    value: /^[\p{L}\p{N} ,.()-]{0,20}$/u,
                    error: window.snakeCheckout.translations["error.field.address.regex"],
                },
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
            },
            zipUS: {
                regex: [
                    {
                        // eslint-disable-next-line no-control-regex
                        value: /^[\p{L}\p{N} ,.()-]{0,20}$/u,
                        error: window.snakeCheckout.translations["error.field.address.regex"],
                    },
                    {
                        preValidation: (element) => element.value.replace(/\D/gu, ""),
                        value: /^(?!99501|99502|99503|99504|99505|99506|99507|99508|99509|99510|99511|99513|99514|99515|99516|99517|99518|99519|99520|99521|99522|99523|99524|99529|99530|99599|99701|99702|99703|99704|99705|99706|99707|99708|99709|99710|99711|99712|99714|99716|99801|99802|99803|99811|99812|99821|99824|99603|99605|99606|99610|99611|99631|99635|99639|99645|99650|99669|99672|99676|99615|99619|99624|99697|99623|99645|99652|99654|99687|99688|99694|99723|99734|99739|99789|99690|99720|99721|99722|99724|99729|99730|99731|99732|99733|99735|99737|99738|99740|99741|99742|99743|99744|99745|99746|99747|99748|99749|99750|99751|99752|99753|99754|99755|99756|99757|99758|99759|99760|99761|99762|99763|99764|99765|99766|99767|99768|99769|99770|99771|99772|99773|99774|99775|99776|99777|99778|99779|99780|99781|99782|99783|99784|99785|99786|99787|99788|99789|96701|96703|96704|96705|96706|96707|96708|96709|96710|96712|96713|96714|96715|96716|96717|96718|96719|96720|96721|96722|96725|96726|96727|96728|96729|96730|96731|96732|96733|96734|96737|96738|96739|96740|96741|96742|96743|96744|96745|96746|96747|96748|96749|96750|96751|96752|96753|96754|96755|96756|96757|96759|96760|96761|96762|96763|96764|96765|96766|96767|96768|96769|96770|96771|96772|96773|96774|96776|96777|96778|96779|96780|96781|96782|96783|96784|96785|96786|96788|96789|96790|96791|96792|96793|96795|96796|96797|96801|96802|96803|96804|96805|96806|96807|96808|96809|96810|96811|96812|96813|96814|96815|96816|96817|96818|96819|96820|96821|96822|96823|96824|96825|96826|96827|96828|96829|96830|96831|96832|96833|96834|96835|96836|96837|96838|96839|96840|96841|96842|96843|96844|96845|96846|96847|96848|96849|96850|00820|00821|00822|00823|00824|00840|00841|00850|00851|00830|00831|00801|00802|00803|00804|00805|00601|00631|00602|00603|00604|00605|00690|00703|00705|00786|00610|00611|00612|00613|00614|00616|00652|00688|00714|00617|00794|00956|00957|00959|00961|00960|00958|00623|00622|00725|00727|00726|00627|00729|00745|00979|00982|00983|00985|00987|00981|00984|00986|00988|00962|00963|00736|00737|00735|00742|00638|00739|00769|00782|00783|00775|00646|00738|00740|00650|00653|00647|00784|00704|00785|00656|00965|00966|00968|00969|00971|00970|00778|00659|00660|00791|00792|00741|00662|00664|00795|00777|00667|00669|00631|00670|00771|00772|00773|00674|00606|00707|00680|00682|00681|00676|00687|00718|00744|00719|00720|00723|00624|00716|00717|00728|00730|00731|00733|00780|00715|00732|00734|00678|00677|00721|00745|00721|00637|00751|00683|00636|00921|00923|00924|00929|00915|00916|00920|00909|00910|00934|00936|00917|00919|00911|00912|00913|00914|00940|00901|00902|00906|00925|00926|00927|00928|00930|00907|00908|00931|00933|00754|00685|00757|00953|00954|00949|00950|00951|00952|00976|00977|00978|00641|00611|00692|00693|00694|00765|00766|00767|00698).*$/u,
                        error: window.snakeCheckout.translations["error.field.address.zip.us"],
                    },
                ],
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
            },
            zipUK: {
                regex: [
                    {
                        // eslint-disable-next-line no-control-regex
                        value: /^[\p{L}\p{N} ,.()-]{0,20}$/u,
                        error: window.snakeCheckout.translations["error.field.address.regex"],
                    },
                    {
                        value: /^((?!(\b(gy(10|[1-9])|je[1-5])\b)).)*$/iu,
                        error: window.snakeCheckout.translations["error.field.address.zip.uk"],
                    },
                ],
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
            },
            zipFrance: {
                regex: [
                    {
                        // eslint-disable-next-line no-control-regex
                        value: /^[\p{L}\p{N} ,.()-]{0,20}$/u,
                        error: window.snakeCheckout.translations["error.field.address.regex"],
                    },
                    {
                        preValidation: (element) => element.value.replace(/\D/gu, ""),
                        // throw a validation error for ZIP codes that starts with the following DOM-TOM ZIP numbers
                        value: /^(?!971|972|973|974|975|976|986|987|988).*$/u,
                        error: window.snakeCheckout.translations["error.field.address.zip.fr"],
                    },
                ],
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
            },
            zipSpain: {
                regex: [
                    {
                        // eslint-disable-next-line no-control-regex
                        value: /^[\p{L}\p{N} ,.()-]{0,20}$/u,
                        postValidation: (element, isValid) => {
                            if (isValid && element.name.startsWith("shipping")) {
                                // Validate the CIF/NIF field if the ZIP code start with a Canarias code (35 or 38)
                                validateConnectedCifNif(element);
                            }

                            return isValid;
                        },
                        error: window.snakeCheckout.translations["error.field.address.regex"],
                    },
                    {
                        preValidation: (element) => element.value.replace(/\D/gu, ""),
                        // throw a validation error for ZIP codes that starts with the following Ceuta or Melilla numbers
                        value: /^(?!510|520).*$/u,
                        error: window.snakeCheckout.translations["error.field.address.zip.es"],
                    },
                ],
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
            },
            fiscalCodeES: {
                regex: {
                    value: /^([IOio]{1}(([0-9]{7}[A-Za-z]{1})|([0-9]{8})))$|^([Tt]{1}[A-Za-z0-9]{8})$|^([0-9]{8}[ABCDEFGHKJYLMNPQRSTVWXZabcdefghkjylmnpqrstvwxz]{1})$|^([KLMklm]{1}(([0-9]{7}[A-Za-z]{1})|([0-9]{8})))$|^([ABCDEFGHJNPQRSUVWabcdefghjnpqrsuvw]{1}(([0-9]{7}[A-Za-z]{1})|([0-9]{8})))$|^([XYZxyz]{1}[0-9]{7}[ABCDEFGHKJYLMNPQRSTVWXZabcdefghkjylmnpqrstvwxz]{1})$/u,
                    postValidation: (element, isValid) => {
                        if (element.parentElement.classList.contains("hidden")) return true;

                        return isValid ? validateCifNif(element) : isValid;
                    },
                    error: window.snakeCheckout.translations["error.field.fiscalcode"],
                },
            },
            notes: {
                regex: {
                    value: /^.{0,100}$/u,
                    error: window.snakeCheckout.translations["error.field.notes.regex"],
                },
            },
            phone: {
                regex: {
                    value: /^[0-9 /()-]+$/,
                    error: window.snakeCheckout.translations["error.field.phone"],
                },
                required: {
                    error: window.snakeCheckout.translations["error.field.required"],
                },
                providers: {
                    numverify: {},
                },
            },
            vatNumberPL: {
                regex: {
                    value: /^((P|p)(L|l))?\d{10}$/,
                    error: window.snakeCheckout.translations["error.field.vatnumber"],
                    postValidation: (element, isValid) => {
                        handleConnectedField(document.querySelector('[data-validate="fiscalCodePL"]'), isValid);

                        return isValid;
                    },
                },
            },
            fiscalCodePL: {
                regex: {
                    value: /^\d{11}$/,
                    error: window.snakeCheckout.translations["error.field.fiscalcode"],
                    postValidation: (element, isValid) => {
                        handleConnectedField(document.querySelector('[data-validate="vatNumberPL"]'), isValid);

                        return isValid;
                    },
                },
            },
            vatNumberIT: {
                regex: [
                    {
                        value: /^(?!(it))/i,
                        error: window.snakeCheckout.translations["error.field.vatnumber.it"],
                    },
                    {
                        value: /^\d{11}$/,
                        error: window.snakeCheckout.translations["error.field.vatnumber"],
                        postValidation: (element, isValid) => {
                            handleConnectedField(document.querySelector('[data-validate="fiscalCodeIT"]'), isValid);

                            return isValid;
                        },
                    },
                ],
            },
            fiscalCodeIT: {
                regex: {
                    value: /^([a-zA-Z]){6}\d{2}([a-zA-Z])\d{2}([a-zA-Z])\d{3}([a-zA-Z])$/,
                    error: window.snakeCheckout.translations["error.field.fiscalcode"],
                    postValidation: (element, isValid) => {
                        handleConnectedField(document.querySelector('[data-validate="vatNumberIT"]'), isValid);

                        return isValid;
                    },
                },
            },
            sdiNumber: {
                regex: {
                    value: /^\w{7}$/,
                    error: window.snakeCheckout.translations["error.field.sdinumber"],
                    postValidation: (element, isValid) => {
                        handleConnectedField(document.querySelector('[data-validate="pec"]'), isValid);

                        return isValid;
                    },
                },
            },
            pec: {
                regex: {
                    value: /^[\w.+-]+@[\w-]+(\.[a-zA-Z]{2,})+$/,
                    error: window.snakeCheckout.translations["error.field.pec"],
                    postValidation: (element, isValid) => {
                        handleConnectedField(document.querySelector('[data-validate="sdiNumber"]'), isValid);

                        return isValid;
                    },
                },
            },
        },
    },
    brands: {
        pw: "deagostini",
        fh: "fanhome",
    },
};

const handleConnectedField = (connectedField, isValid) => {
    connectedField.disabled = false;

    if (isValid) {
        connectedField.disabled = true;
        connectedField.value = "";
        connectedField.classList.remove("valid", "invalid", "error");

        if (connectedField.parentElement.querySelector(":scope small")) connectedField.parentElement.querySelector(":scope small").remove();
    }
};

const validateTags = (element, isValid) => {
    const el = element.parentElement.querySelector("tags.tagify");

    el.classList.remove("valid", "invalid");
    el.classList.add(isValid ? "valid" : "invalid");
};

const validateConnectedCifNif = (element) => {
    const field = element.parentElement.parentElement.querySelector('[name$="[taxCode]"]');

    if (field) {
        if (["35", "38"].some((check) => element.value.trim().replace(/\D/gu, "").startsWith(check))) {
            const isValid = Validate.validateField(field, config.validation.rules.fiscalCodeES, true);

            field.dataset.validateCheck = isValid;

            field.parentElement.classList.remove("hidden");
        } else {
            field.dataset.validateCheck = true;

            field.parentElement.classList.add("hidden");
        }
    }
};

const validateCifNif = (field) => {
    const value = field.value.toUpperCase();

    const regex = /^(?<m1>([0-9]{8}[ABCDEFGHKJYLMNPQRSTVWXZabcdefghkjylmnpqrstvwxz]{1}))$|^(?<m2>([KLMklm]{1}(([0-9]{7}[A-Za-z]{1})|([0-9]{8}))))$|^(?<m3>([ABCDEFGHJNPQRSUVWabcdefghjnpqrsuvw]{1}(([0-9]{7}[A-Za-z]{1})|([0-9]{8}))))$|^(?<m4>([XYZxyz]{1}[0-9]{7}[ABCDEFGHKJYLMNPQRSTVWXZabcdefghkjylmnpqrstvwxz]{1}))$/u;

    const matches = value.match(regex);

    const DNI = "TRWAGMYFPDXBNJZSQVHLCKE";

    // eslint-disable-next-line eqeqeq
    if (matches?.groups.m1 != undefined) {
        if (value[8] !== DNI[value.substring(8, 0) % 23]) return false;
    }

    let t = "";
    let sum = parseInt(value[2]) + parseInt(value[4]) + parseInt(value[6]);

    for (let i = 1; i < 8; i += 2) {
        t = (2 * parseInt(value[i])).toString();
        sum += parseInt(t.substring(0, 1)) + parseInt(t.substring(1, 2) || "0");
    }

    sum = sum.toString();

    const number = 10 - parseInt(sum.substring(sum.length - 1, sum.length));

    // eslint-disable-next-line eqeqeq
    if (matches?.groups.m2 != undefined) {
        if (value[8] !== String.fromCharCode(64 + number)) return false;
    }

    // eslint-disable-next-line eqeqeq
    if (matches?.groups.m3 != undefined) {
        const n = number.toString();

        if (value[8] !== String.fromCharCode(64 + number) && parseInt(value[8]) !== parseInt(n.substring(n.length - 1, n.length))) return false;
    }

    // eslint-disable-next-line eqeqeq
    if (matches?.groups.m4 != undefined) {
        const position = value.replaceAll("X", "0").replaceAll("Y", "1").replaceAll("Z", "2").substring(0, 8) % 23;

        if (value[8] !== DNI.substring(position, position + 1)) return false;
    }

    return true;
};

export default config;
